const WEEKDAYS = [
  { day: "monday", short: "Mon" },
  { day: "tuesday", short: "Tue" },
  { day: "wednesday", short: "Wed" },
  { day: "thursday", short: "Thu" },
  { day: "friday", short: "Fri" },
  { day: "saturday", short: "Sat" },
  { day: "sunday", short: "Sun" },
];

function formatTime12h(time24) {
  if (!time24 || typeof time24 !== "string") return time24;
  const [hStr, mStr] = time24.split(":");
  const hours = Number(hStr);
  const minutes = Number(mStr);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return time24;
  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;
  return `${hour12}:${String(minutes).padStart(2, "0")} ${period}`;
}

function dayKey(day) {
  if (!day?.isOpen || !day.open || !day.close) return "closed";
  return `${day.open}-${day.close}`;
}

/**
 * Parse organization.operating_hours into display rows.
 * Returns null when nothing is configured.
 * @returns {{ label: string, time: string, isClosed: boolean }[] | null}
 */
export function getOperatingHoursRows(hours) {
  if (!hours || typeof hours !== "object" || !Array.isArray(hours.days)) return null;

  const byDay = new Map(
    hours.days
      .filter((d) => d && typeof d.day === "string")
      .map((d) => [d.day, d])
  );

  const ordered = WEEKDAYS.map(({ day, short }) => {
    const entry = byDay.get(day);
    return {
      day,
      short,
      isOpen: Boolean(entry?.isOpen),
      open: entry?.open || null,
      close: entry?.close || null,
    };
  });

  if (!ordered.some((d) => d.isOpen && d.open && d.close)) return null;

  const groups = [];
  for (const day of ordered) {
    const key = dayKey(day);
    const last = groups[groups.length - 1];
    if (last && last.key === key) {
      last.end = day.short;
    } else {
      groups.push({ start: day.short, end: day.short, key });
    }
  }

  return groups.map((group) => {
    const label = group.start === group.end ? group.start : `${group.start}–${group.end}`;
    if (group.key === "closed") {
      return { label, time: "Closed", isClosed: true };
    }
    const [open, close] = group.key.split("-");
    return {
      label,
      time: `${formatTime12h(open)} – ${formatTime12h(close)}`,
      isClosed: false,
    };
  });
}

/**
 * Format organization.operating_hours into a multi-line display string.
 * Returns null when nothing is configured.
 */
export function formatOperatingHours(hours) {
  const rows = getOperatingHoursRows(hours);
  if (!rows) return null;
  return rows.map((row) => `${row.label}: ${row.time}`).join("\n");
}
